<template>
    <div>
        <card>
            <h2 style="color:#00467f;margin-top:10px;margin-left:5px;font-weight:bold;text-align:left">Nota di Credito - CARICA FILE</h2>
            <div class="form-row justify-content-center">
                <div class="form-group">
                    <h3 for="file" style="margin-bottom:20px">Carica scansione fattura</h3>
                    <button class="btn" style="margin-left:10px;font-size:12px;background:#00467f">Scegli file<input class="form-control" type="file" multiple name="documento" ref="file" v-on:change="checkFileUpload()"></button>
                </div>
            </div>
           
            <div class="row justify-content-start" style="margin-top:10px;">
                <div class="col">
                <div v-if="fileCaricati.length > 0" style="margin-top:15px">
                    <p>File caricati:</p>
                    <div v-for="value in fileCaricati" v-bind:key="value.ID">
                    <p><a :href="'https://sviluppoallergeni.confcom.it'+ value.VALUE.url + '?token='+access_token" target="_blank" style="color:black">{{value.VALUE.name}}</a></p>
                    </div><!-- "'https://sviluppoallergeni.confcom.it'+ value.NAME  + '?token='+access_token"-->
                </div>
                <div v-else></div>
                </div>
                <div class="col"></div>
                <div class="col"></div>
            </div>
            <button type="button" class="btn float-right" style="background:#00467f" v-on:click="salvaValori()">Salva</button>
        </card>
        
        <!--  MODAL CARICARE FILE -->
        <b-modal v-model="showCheckFile" size="md">
            <template #modal-header="{ close }">
                <b-button size="sm" style="background:#00467f;" @click="close()">X</b-button>
            </template>
            <template>
                <h3 style="color:black; text-align:center; margin-top:15px">Sicuro di voler caricare il documento?</h3>
                <div class="container">
                <div id="preloader_3" v-if="showLoader"></div>
                </div>
            </template>
            <template #modal-footer="{ cancel }">
                <span  v-if="!showLoader" style="padding-left:40px;"><b-button size="sm" variant="danger" @click="cancel()">NO</b-button></span>
                <span  v-if="!showLoader" style="padding-right:40px;"><b-button size="sm"  style="background:#00467f;" @click="handleFileUpload()">SI</b-button></span>
            </template>
        </b-modal>
    </div>
</template>
<script>
import axios from 'axios';
import Card from '@/components/Cards/Card.vue';
import {Modal} from '@/components';
import Services from '@/services/Services';
import NoteServices from '@/services/NoteServices';

export default {
    components: {
      Card,
      Modal
    },
  
    data() {
        return {
            modals: {
                mini: false
            },
            valor: [],
            file: null,
            showCheckFile: false,
            showLoader: false,
            fileCaricati: [],

            //pop up per cercare 
            showRisultati: false,
            nessunRisulato: false,
            
            idNota: null,
            access_token: null,
            token_response: [],
            urlRichieste: 'https://sviluppoallergeni.confcom.it/'   //'https://apiintranet.confcom.it/'
        }
    },
    methods: {
        checkFileUpload: function() {
            this.showCheckFile = true;
        },

        handleFileUpload: async function(){
            this.showLoader = true;
            let token = localStorage.getItem('access_token');
            let risposta;
            let errore = 0;
            this.file = this.$refs.file.files[0];
            let formData = new FormData()
            formData.append('documento', this.file)
            await axios.post(
                this.urlRichieste + 'accredito/'+this.idNota+'/meta',
                formData,
                    {
                    withCredentials: true,
                    headers: {
                    'Content-type': 'multipart/form-data',
                    'Authorization': `Bearer ${token}`
                    }
                }
            )
            .then(response => { risposta = response.data})
            .catch( function (error) {
            // handle error
            if(error.response.status == 401){
                errore = error.response.status;
            }
            })
            if (errore == 401) {
                console.log(`errore 401`);
                let value = await this.refreshToken();
                if (value) { await this.handleFileUpload(); }
            }
            this.showCheckFile = false;
            this.showLoader = false;
            await this.getFileCaricati();
        },

        getFileCaricati: async function() {
            let errore = 0;
            // let response_dati = [];
            await NoteServices.caricaNota(this.idNota)
            .then(response => { this.valori = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if(errore == 401){
                let value = await this.refreshToken();
                if (value) { await this.getFileCaricati(); }
            }
            if (this.valori.A_ACCREDITO_META.length > 0) {
                this.fileCaricati = this.valori.A_ACCREDITO_META;
                console.log(`accredito meta`);
                console.log(this.fileCaricati);
            }
        },

        handleremoveFile: function(){
            this.file = null;
        },

        logout: async function () {
            await Services.logout()
            .then(response => { this.results = response.data})
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.setItem('isLogged', false);
            localStorage.removeItem('user_nome');
            localStorage.removeItem('user_cognome');
            localStorage.removeItem('user_tipologia');
            localStorage.removeItem('user_email');
            localStorage.removeItem('user_livello');
            localStorage.removeItem('user_id');
            this.$router.push({
            path: '/login'
            })
        },
        
        refreshToken: async function() {
            let errore = 0;
            await Services.refreshToken()
            .then(response => { this.token_response = response.data})
            .catch(function (error) {
                // handle error
                if(error.response.status == 403 || error.response.status == 401){
                    errore = error.response.status;
                }
            })
            if (errore == 403 || errore == 401) {
                await this.logout();
                return false;
            }
            localStorage.setItem("access_token", this.token_response.accessToken);
            this.access_token = localStorage.getItem('access_token');
            return true;
        },

        salvaValori: async function() {
            // let id_user = localStorage.getItem('user_id');
            // let dati = []; 
            // let errore = 0;
            this.$router.push({
                path: '/note-credito'
            })
            
        },

        main: async function() {
            this.user_livello = localStorage.getItem('user_livello');
            this.idNota = this.$route.query.id;
            console.log(`idNota=${this.idNota}.`);
            this.access_token = localStorage.getItem('access_token');
            axios.defaults.withCredentials = true;
            try {
                if (this.idNota != null ) { //&& this.idNota != ''
                    // await this.caricaNota();
                    this.getFileCaricati();
                }
            } catch (error) {
                if (error.response.status == 401) {
                    await this.refreshToken();
                }
            }
            
        }
    },

    mounted() {
        
    },
    beforeMount() {
        this.main();
    }
  };
</script>
<style scoped>
/* body {
    margin: 10px; 
     padding: 10px;
} */
form {
    /* max-width: 580px; */
    margin: auto;
}
label {
    font-size: 18px;
}
.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.input-icon {
  position: relative;
}

.input-icon > i {
  position: absolute;
  display: block;
  transform: translate(0, -50%);
  top: 50%;
  pointer-events: none;
  width: 25px;
  text-align: center;
	font-style: normal;
}

.input-icon > input {
  padding-left: 25px;
  padding-right: 0;
}

.input-icon-right > i {
  right: 0;
}

.input-icon-right > input {
  padding-left: 0;
  padding-right: 25px;
  text-align: right;
}

</style>
  